import { directive, AttributePart } from "lit-html";

export interface Ref<T = Element> {
  value: null | T;
}

export function createRef<T = Element>(): Ref<T> {
  return {
    value: null,
  };
}

/**
 * react like `ref` / lit-html@v2.x directive for lit-html@v1.x
 * @example
 *   const inputRef = createRef<HTMLInputElement>();
 *   render(html`<input ref=${ref(inputRef)}`) />`)
 *   inputRef.value.focus();
 *
 *   render(html`<img ref=${ref(el => lazyload(el))}`) />`)
 */
export const ref = directive((refOrCallback: Ref | Function) => (attributePart: AttributePart) => {
  const element = attributePart.committer.element;
  if (typeof refOrCallback === "function") refOrCallback(element);
  else if (typeof refOrCallback === "object") refOrCallback.value = element;
});
